import React, { useState } from "react";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import '../Funciones/ExcelEditor.css';


// Componente principal
const ExcelEditor = () => {
  // Estados para manejar los datos y estilos de la tabla
  const [data, setData] = useState([]); // Almacena los datos de la tabla
  const [columnWidths, setColumnWidths] = useState([]); // Ancho de columnas
  const [cellStyles, setCellStyles] = useState({}); // Estilos de celdas
  const [tableWidth, setTableWidth] = useState(900); // Ancho dinámico de la tabla
  const [fillLetter, setFillLetter] = useState("");
  const [comments, setComments] = useState("");
  const [lockedCells, setLockedCells] = useState(new Set());
 

  // Manejo de la carga del archivo Excel
  const handleFileUpload = (event) => {
    const file = event.target.files[0]; // Obtiene el archivo seleccionado
    if (!file) return; // Si no hay archivo, salir de la función
    const reader = new FileReader(); // Crea un lector de archivos
    reader.onload = (e) => {
      const binaryStr = e.target.result; // Obtiene los datos del archivo en binario
      const workbook = XLSX.read(binaryStr, { type: "binary", cellStyles: true }); // Lee el archivo Excel
      const sheetName = workbook.SheetNames[0]; // Obtiene el nombre de la primera hoja
      const sheet = workbook.Sheets[sheetName]; // Obtiene los datos de la hoja

      // Detecta el rango de la tabla en la hoja de Excel
      const range = sheet["!ref"];
      if (!range) return;

      // Convierte la hoja en un array de arrays, incluyendo celdas vacías
      const sheetData = XLSX.utils.sheet_to_json(sheet, { header: 1, defval: "", range });
      setData(sheetData); // Guarda los datos en el estado
      
      const cellDimensions = {}; // Objeto para almacenar dimensiones de celdas
      let totalWidth = 0; // Variable para calcular el ancho total de la tabla

      // Itera sobre las celdas del archivo para obtener dimensiones
      Object.keys(sheet).forEach((cell) => {
        if (sheet[cell].s) {
          const width = sheet[cell].s.wpx || 100; // Ancho en píxeles
          const height = sheet[cell].s.hpx || 20; // Alto en píxeles
          cellDimensions[cell] = { width, height }; // Guarda dimensiones
        }
      });

      // Obtiene los anchos de columnas desde "!cols"
      const excelCols = sheet["!cols"] || [];
      const columnWidths = sheetData[0].map((_, colIndex) => {
        return excelCols[colIndex]?.wpx || 100;
      });

      totalWidth = columnWidths.reduce((sum, width) => sum + width, 0); // Calcula el ancho total

      // Actualiza los estados con los valores obtenidos
      setCellStyles(cellDimensions);
      setColumnWidths(columnWidths);
      setTableWidth(Math.max(200, Math.min(800, totalWidth))); // Ajusta el ancho de la tabla
      //-------------------------------------------------
         // Bloquear solo celdas con contenido inicial
          const initialLockedCells = new Set();
          sheetData.forEach((row, rowIndex) => {
            row.forEach((cell, colIndex) => {
              if (cell !== "") {
                initialLockedCells.add(`${rowIndex}-${colIndex}`);
              }
            });
          });

          setLockedCells(initialLockedCells); // Bloquear solo celdas originales
      //------------------------------------------------
    };
    
    reader.readAsBinaryString(file); // Lee el archivo como binario
  };

  const handleCellChange = (rowIndex, colIndex, value) => {
    setData(prevData => {
      const newData = [...prevData];
      newData[rowIndex] = [...(newData[rowIndex] || [])];
      newData[rowIndex][colIndex] = value;
      return newData;
    });
  
    // No bloquear las celdas editadas por el usuario
    setLockedCells(prev => {
      const updated = new Set(prev);
      updated.delete(`${rowIndex}-${colIndex}`); // Desbloquear celdas editadas
      return updated;
    });
  };
  // Rellenar vacíos y BLOQUEAR todas las celdas modificadas
  const handleFillEmpty = () => {
    if (!fillLetter) return;

    const filledCells = [];
    setData(prevData => {
      const newData = prevData.map((row, rowIndex) => 
        row.map((cell, colIndex) => {
          if (cell === "") {
            filledCells.push(`${rowIndex}-${colIndex}`);
            return fillLetter;
          }
          return cell;
        })
      );
      return newData;
    });

    // Bloquear todas las celdas llenadas de una vez
   // setLockedCells(prev => new Set([...prev, ...filledCells]));
  };
  //------------------------------------------------------------------

  // Generar PDF
  const generatePDF = () => {
    const doc = new jsPDF();
    let yPos = 20;

    // Agregar datos de la tabla
    data.forEach((row, idx) => {
      doc.text(20, yPos, `Fila ${idx + 1}: ${row.join(" | ")}`);
      yPos += 10;
      if (yPos > 280) {
        doc.addPage();
        yPos = 20;
      }
    });

    // Agregar comentarios
    doc.text(20, yPos + 10, "Comentarios:");
    doc.text(20, yPos + 20, comments);

    doc.save("documento-generado.pdf");
  };



  return (
  <div>
    {/* Input para seleccionar archivo Excel */}
        <input type="file" accept=".xls,.xlsx" onChange={handleFileUpload} />
        <div className="fill-controls">
          <input
            type="text"
            placeholder="Letra para celdas vacías"
            maxLength="1"
            value={fillLetter}
            onChange={(e) => setFillLetter(e.target.value.toUpperCase())}
          />
          <button onClick={handleFillEmpty}>Rellenar vacías</button>
          <button onClick={generatePDF}>Descargar PDF</button>
        </div>
    <div style={{
      width: `${tableWidth}px`,
      maxHeight: "400px",
      minWidth: "200px",
      minHeight: "300px",
      overflow: "auto",
      border: "1px solid black",
      padding: "10px"
    }}>
      
        
      
      {/* Tabla con datos de Excel */}
      <table style={{ borderCollapse: "collapse", width: "100%" }}>
       <colgroup>
          {columnWidths.map((width, index) => (
            <col key={index} style={{ width: `${width}px` }} />
          ))}
        </colgroup>
        <tbody>
          {data.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {Array.from({ length: Math.max(...data.map(r => r.length), 1) }).map((_, colIndex) => {
                const cellKey = XLSX.utils.encode_cell({ r: rowIndex, c: colIndex });
                const style = cellStyles[cellKey] || {};
                const cellValue = row[colIndex] || "";
                return (
                  <td
                    key={colIndex}
                    style={{
                      width: columnWidths[colIndex] || 100,
                      height: style.height,
                      border: "1px solid black",
                      padding: "2px",
                      textAlign: "center",
                      fontSize: "12px"
                    }}
                  >
                    <div>
                      {/* Input para edición de celdas */}
                      <input
                        type="text"
                        value={cellValue}
                        onChange={(e) => handleCellChange(rowIndex, colIndex, e.target.value)}
                        disabled={lockedCells.has(`${rowIndex}-${colIndex}`)} // Solo bloquear las originales
                        style={{ width: "100%", height: "100%", border: "none" }}
                      />
                    </div>
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
     
    </div>
    {/* Área de comentarios y descarga */}
    <div className="footer-controls">
        <textarea  style={{width:'800px'}}
          placeholder="Agregar comentarios..."
          value={comments}
          onChange={(e) => setComments(e.target.value)}
        />
       
      </div>
  </div>
  );
};

export default ExcelEditor;
